import i18n from "features/shared/i18n";

interface StatsCardsProps {
  status?: {
    course: { finished: number; total: number };
    project: { total: number; published: number; favorited: number };
  };
}

export const StatsCards = ({ status }: StatsCardsProps) => {
  return (
    <div className="grid grid-cols-4 gap-4">
      <div className="bg-white rounded-[16px] p-5 flex-row-el gap-4 hover:-translate-y-0.5 hover:shadow-lg transition-all">
        <div className="w-12 h-12 rounded-[12px] bg-[rgba(76,157,241,0.15)] flex items-center justify-center">
          <span className="material-symbols-outlined text-[42px] text-blue-100">map</span>
        </div>
        <div className="flex-1">
          <div className="text-[42px] text-textcolor-black">
            {status?.course.finished ?? 0}
            <span className="text-[24px] font-normal text-gray2-100">
              /{status?.course.total ?? 0}
            </span>
          </div>
          <div className="text-[19px] text-gray2-100 mt-0.5">
            {i18n.t("MSG_PARENT_PAGE_COURSE_CLEAR")}
          </div>
          <div className="h-1.5 bg-outline rounded-full overflow-hidden mt-2">
            <div
              className="h-full bg-blue-100 rounded-full transition-all"
              style={{
                width: `${((status?.course.finished ?? 0) / Math.max(status?.course.total ?? 1, 1)) * 100}%`,
              }}
            />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-[16px] p-5 flex-row-el gap-4 hover:-translate-y-0.5 hover:shadow-lg transition-all">
        <div className="w-12 h-12 rounded-[12px] bg-[rgba(255,191,0,0.15)] flex items-center justify-center">
          <span className="material-symbols-outlined text-[42px] text-orange-100">folder</span>
        </div>
        <div className="flex-1">
          <div className="text-[42px] text-textcolor-black">{status?.project.total ?? 0}</div>
          <div className="text-[19px] text-gray2-100 mt-0.5">
            {i18n.t("MSG_PARENT_PAGE_CREATED_PROJECTS")}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-[16px] p-5 flex-row-el gap-4 hover:-translate-y-0.5 hover:shadow-lg transition-all">
        <div className="w-12 h-12 rounded-[12px] bg-[rgba(43,220,152,0.15)] flex items-center justify-center">
          <span className="material-symbols-outlined text-[42px] text-green-100">public</span>
        </div>
        <div className="flex-1">
          <div className="text-[42px] text-textcolor-black">{status?.project.published ?? 0}</div>
          <div className="text-[19px] text-gray2-100 mt-0.5">
            {i18n.t("MSG_PARENT_PAGE_PUBLISHED_PROJECTS")}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-[16px] p-5 flex-row-el gap-4 hover:-translate-y-0.5 hover:shadow-lg transition-all">
        <div className="w-12 h-12 rounded-[12px] bg-[rgba(252,101,96,0.15)] flex items-center justify-center">
          <span className="material-symbols-outlined text-[42px] text-danger">favorite</span>
        </div>
        <div className="flex-1">
          <div className="text-[42px] text-textcolor-black">{status?.project.favorited ?? 0}</div>
          <div className="text-[19px] text-gray2-100 mt-0.5">
            {i18n.t("MSG_PARENT_PAGE_RECEIVED_LIKES")}
          </div>
        </div>
      </div>
    </div>
  );
};
